import React from 'react';

const ArrowLabel = () => (
  <svg width="31" height="20" viewBox="0 0 31 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M0.813004 10.2755C0.813004 9.69059 1.28715 9.21645 1.87204 9.21645L26.8501 9.21645L20.1858 2.55207C19.7722 2.1385 19.7722 1.46795 20.1858 1.05438C20.5993 0.640799 21.2699 0.640799 21.6835 1.05438L30.1557 9.52663C30.5693 9.94021 30.5693 10.6107 30.1557 11.0243L21.6835 19.4966C21.2699 19.9102 20.5993 19.9102 20.1858 19.4966C19.7722 19.083 19.7722 18.4125 20.1858 17.9989L26.8501 11.3345L1.87204 11.3345C1.28715 11.3345 0.813004 10.8604 0.813004 10.2755Z" fill="black"/>
</svg>
);

export default ArrowLabel;